import type { ChecklistTemplate, ChecklistTemplateBase } from "../../types";
import { createBaseService } from "./baseService";

const base = createBaseService<ChecklistTemplate, ChecklistTemplateBase>({
  tableName: "checklist_templates",
  searchColumns: ["name"],
  computedColumns: ["linkedWoCount"],
});

export class ChecklistService {
  static getAll = base.getAll;
  static get = base.get;
  static create = base.create;
  static update = base.update;
  static delete = base.delete;
}
